import { IncidentDetail } from '@hakimo-ui/hakimo/types';
import { Button } from '@hakimo-ui/shared/ui-base';
import { ImagePlus } from 'lucide-react';
import { EmailSentNote } from './EmailSentNote';
import { FIELD_LABEL_CLASS } from './Panel';

interface Props {
  incident: IncidentDetail;
  preparing: boolean;
  sending: boolean;
  downloading: boolean;
  onPreviewAndSend: () => void;
  onDownload: () => void;
  onOpenLogoModal: () => void;
}

export function IncidentDetailsHeader({
  incident,
  preparing,
  sending,
  downloading,
  onPreviewAndSend,
  onDownload,
  onOpenLogoModal,
}: Props) {
  return (
    <div className="dark:bg-ondark-bg-1 bg-onlight-bg-1 flex items-center justify-between gap-4 rounded-lg px-4 py-3">
      <div className="flex items-baseline gap-3">
        <span className={FIELD_LABEL_CLASS}>Alarm ID</span>
        <span className="text-onlight-text-1 dark:text-ondark-text-1 text-lg font-semibold">
          {incident.alarm_id}
        </span>
      </div>
      <div className="flex items-center gap-3">
        {incident.email_sent_at_utc ? (
          <EmailSentNote
            sentAtUtc={incident.email_sent_at_utc}
            sentBy={incident.email_sent_by}
            zone={incident.timezone}
          />
        ) : (
          <Button
            variant="primary"
            onClick={onPreviewAndSend}
            loading={preparing}
            disabled={preparing || sending}
          >
            Preview and Send Report
          </Button>
        )}
        <Button
          variant="primary"
          onClick={onDownload}
          loading={downloading}
          disabled={downloading}
        >
          Download Report
        </Button>
        <button
          type="button"
          onClick={onOpenLogoModal}
          aria-label="Set report logo"
          title={
            incident.report_logo_url ? 'Change report logo' : 'Add report logo'
          }
          className="text-onlight-text-2 dark:text-ondark-text-2 dark:hover:bg-ondark-bg-3 hover:bg-onlight-bg-2 border-onlight-line-2 dark:border-ondark-line-2 relative shrink-0 rounded-md border p-1.5"
        >
          <ImagePlus className="h-5 w-5" />
          {incident.report_logo_url && (
            <span className="dark:ring-ondark-bg-1 ring-onlight-bg-1 absolute -right-0.5 -top-0.5 h-2 w-2 rounded-full bg-red-500 ring-2" />
          )}
        </button>
      </div>
    </div>
  );
}

export default IncidentDetailsHeader;
